/** Mesmo host usado em `SocketContext` e nos probes do console da plataforma. */
export const SOCKET_SERVER_URL = "https://socket.xpro.me:3000";
